import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconTickRound = ({ id, color, width = 13, style, ...restProps }: IProps) => {
  const viewBoxWidth = 13;
  const viewBoxHeight = 11;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      width={`${width}px`}
      height={`${height}px`}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}>
      <g transform="matrix(1,0,0,1,-0.60013,-0.0453504)">
        <path
          d="M0.819,5.893L4.194,10.117C4.378,10.348 4.656,10.485 4.952,10.492C5.247,10.499 5.531,10.375 5.726,10.153L13.151,1.705C13.515,1.291 13.475,0.658 13.06,0.294C12.646,-0.07 12.013,-0.03 11.649,0.385L5.011,7.936C5.011,7.936 2.381,4.645 2.381,4.645C2.037,4.213 1.407,4.143 0.976,4.488C0.545,4.832 0.474,5.462 0.819,5.893Z"
          style={{ fill: iconColor }}
        />
      </g>
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconTickRound;
